import { useState } from 'react';
import { Button, Modal, ModalFooter, ModalTitle } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as LinkedinIcon } from 'src/images/svgs/socials/linkedin.svg';
import { useTrackEventMutation } from 'src/common/slices/analytics';
import { SocialName } from 'src/common/page-share';
import { StyledContentWrapper, StyledInfoBox, StyledLinkedinLink } from './share-certificate-modal.styles';
import { ShareCertificateModalProps } from './share-certificate-modal.types';
export const ShareCertificateModal = ({
  dateIssued,
  url,
  certId,
  name,
  imageUrl,
  modalBtn
}: ShareCertificateModalProps) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const date = dateIssued && new Date(dateIssued);
  const year = date && date.getFullYear();
  const month = date && date.getMonth() + 1;
  const hasLoaded = month && year && url && certId && name;
  const [trackEvent] = useTrackEventMutation();
  const toggleShareModal = () => {
    if (!isPopUpOpen) {
      // eslint-disable-next-line no-void
      void trackEvent({
        event: 'click-share-preview',
        properties: {
          name,
          certificate_type: 'certificate of completion'
        }
      });
    }
    setIsPopUpOpen(!isPopUpOpen);
  };
  const trackShareCertificate = () => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'social-share',
      properties: {
        achievement: 'certificate',
        page: 'certificate-preview',
        medium: SocialName.linkedin,
        name,
        certificate_type: 'certificate of completion'
      }
    });
  };
  const trackCopyCertificateUrl = () => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'copy-url-certificate',
      properties: {
        name,
        certificate_type: 'certificate of completion'
      }
    });
  };
  return <Modal onOpenChange={toggleShareModal} open={isPopUpOpen} triggerElement={modalBtn || <Button color="add" disabled={!hasLoaded}>
            <FontAwesomeIcon icon={faShare} />
            Share
          </Button>} data-sentry-element="Modal" data-sentry-component="ShareCertificateModal" data-sentry-source-file="share-certificate-modal.tsx">
      <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="share-certificate-modal.tsx">Share certificate</ModalTitle>
      <StyledContentWrapper data-sentry-element="StyledContentWrapper" data-sentry-source-file="share-certificate-modal.tsx">
        <p data-title="title">Share on social media</p>
        <p>
          Stand out in the Cybersecurity community! Share your new certificate on LinkedIn and showcase your
          achievements.
        </p>
        <StyledLinkedinLink href={hasLoaded ? `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${name}%20Certificate&organizationId=14055650&issueYear\
=${year}&issueMonth=${month}&certUrl=${url}&certId=${certId}` : ''} target="_blank" rel="noopener noreferrer" onClick={trackShareCertificate} data-sentry-element="StyledLinkedinLink" data-sentry-source-file="share-certificate-modal.tsx">
          <LinkedinIcon data-sentry-element="LinkedinIcon" data-sentry-source-file="share-certificate-modal.tsx" />
          Share on LinkedIn
        </StyledLinkedinLink>
        <p data-title="title">Credential URL</p>
        <StyledInfoBox linkButtonType="button" textToCopy={imageUrl} handleAfterCopy={trackCopyCertificateUrl} data-sentry-element="StyledInfoBox" data-sentry-source-file="share-certificate-modal.tsx">
          <p>{imageUrl}</p>
        </StyledInfoBox>
      </StyledContentWrapper>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="share-certificate-modal.tsx">
        <Button variant="outlined" color="secondary" onClick={() => setIsPopUpOpen(false)} data-sentry-element="Button" data-sentry-source-file="share-certificate-modal.tsx">
          Close
        </Button>
      </ModalFooter>
    </Modal>;
};